import { Flex } from 'antd';
import { DateTime } from 'luxon';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {
    COLOR_ITEM,
    FORMAT_TIME_DISPLAY,
    GAP_COLUMN_AGENDA,
    WIDTH_COLUMN_AGENDA_ITEM_TASK,
    WIDTH_COLUMN_AGENDA_TIME,
} from '../const';
import { ComponentsDispatch, RootState } from '../store';
import { setterCalendar } from '../store/slices/calendarSlice';
import { ItemTaskType, ItemType, MappingItemIdIndexType } from '../types';

interface ICalendarTaskMonth {
    task: ItemTaskType;
    isShowLeftDataPanel?: boolean;
}

const CalendarTaskMonth: React.FC<ICalendarTaskMonth> = ({ task, isShowLeftDataPanel }) => {
    const dispatch = useDispatch<ComponentsDispatch>();
    const items = useSelector<RootState, ItemType[]>((state) => state.calendar.items);
    const mappingItemIdIndex = useSelector<RootState, MappingItemIdIndexType>(
        (state) => state.calendar.mappingItemIdIndex,
    );
    const currentTask = useSelector<RootState, ItemTaskType | null>((state) => state.calendar.currentTask);

    const backgroundColor =
        task.color || (task.schedule_item_id ? items[mappingItemIdIndex[task.schedule_item_id!]].color : COLOR_ITEM);
    const renderTask = () => {
        return (
            <Flex
                key={task.id}
                onClick={() => {
                    dispatch(setterCalendar({ currentTask: task }));
                }}
                style={{
                    cursor: 'pointer',
                    fontSize: 'clamp(9px, 1.1vw, 14px)',
                }}
            >
                <span
                    style={{
                        display: 'block',
                        borderRadius: 10,
                        backgroundColor,
                        width: 'clamp(9px, 0.8vw, 12px)',
                        height: 'clamp(9px, 0.8vw, 12px)',
                        marginTop: 'clamp(2px, 0.5vw, 6px)',
                        marginRight: 5,
                    }}
                ></span>
                <span
                    style={{
                        textOverflow: 'ellipsis',
                        overflow: 'hidden',
                        whiteSpace: 'nowrap',
                        fontWeight: currentTask?.id === task.id ? 'bold' : 'normal',
                    }}
                >
                    {task.name}
                </span>
            </Flex>
        );
    };

    return isShowLeftDataPanel ? (
        <Flex justify={'start'} gap={GAP_COLUMN_AGENDA}>
            <div style={{ width: WIDTH_COLUMN_AGENDA_TIME }}>
                {DateTime.fromISO(task.start_datetime).toFormat(FORMAT_TIME_DISPLAY)} -{' '}
                {DateTime.fromISO(task.end_datetime).toFormat(FORMAT_TIME_DISPLAY)}
            </div>
            <div style={{ width: WIDTH_COLUMN_AGENDA_ITEM_TASK }}>{renderTask()}</div>
        </Flex>
    ) : (
        renderTask()
    );
};

export default CalendarTaskMonth;
